import { BoxProps, Box, Center } from '@chakra-ui/react';
import { CarouselProvider, Slider, Slide, DotGroup, Dot } from 'pure-react-carousel';
import cm from 'src/assets/images/reviews/cm.png';
import 'pure-react-carousel/dist/react-carousel.es.css';
import colors from 'src/theme/colors';
import Review from './Review';

function ReviewsContainer(props: BoxProps) {
  return (
    <Box
      background={colors.white}
      border={`2px solid ${colors.podcastShade200}`}
      boxSizing="border-box"
      boxShadow="inset 0px -3px 10px rgba(205, 204, 227, 0.15)"
      borderRadius="12px"
      p="20px"
      as="a"
      w="100%"
      display="block"
      {...props}
    />
  );
}

export default function ReviewCarousel() {
  return (
    <>
      {' '}
      <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={100}
        isIntrinsicHeight
        totalSlides={3}
        isPlaying
      >
        <a href="https://uk.trustpilot.com/review/alitu.com" target="_blank" rel="noreferrer">
          <ReviewsContainer>
            <Slider>
              <Slide index={0}>
                <Review name="Caroline Moassessi" title="Incredible Support" image={cm}>
                  The secret sauce of using Alitu is that someone like me, who is not tech savvy can
                  excel at creating professional podcasts for a national food allergy advocacy
                  organization. If I ever run into trouble, Alitu&apos;s kind staff listens closely
                  and then works to help me. I never panic when I run across a challenge since I
                  know Alitu has my back!
                </Review>
              </Slide>
              <Slide index={1}>
                <Review name="Sheena Tidwell" title="Absolutely worth the money">
                  I went back and forth a few times on this during the free trial, I wasn&apos;t
                  sure if it would truly be something I needed. I have Adobe audition, and am
                  relatively familiar with audio editing. Let me just say, the program is worth it!
                  Alitu makes editing so much easier than I thought it would be! My podcast is
                  something I didn&apos;t want to spend a lot of time editing, and now I don&apos;t
                  have to.
                </Review>
              </Slide>
              <Slide index={2}>
                <Review name="Kate W" title="Podcast editing made easy">
                  Podcast editing made easy! I approached the task daunted by other editing software
                  but then found Alitu and it is so easy and has so many great tools, like recording
                  straight onto the platform and they even give you music if you need it. Highly
                  recommend.
                </Review>
              </Slide>
            </Slider>
          </ReviewsContainer>
        </a>
        <Center mt="27px">
          <DotGroup
            renderDots={({ currentSlide, totalSlides = 0 }) => {
              const dots = [];
              for (let i = 0; i < totalSlides; i += 1) {
                const selected = !!(i === currentSlide);
                dots.push(
                  <Dot key={i} slide={i}>
                    <Box
                      bg={selected ? 'podcastShade500' : 'podcastShade300'}
                      w={selected ? '8px' : '6px'}
                      h={selected ? '8px' : '6px'}
                      mb={selected ? '0px' : '1px'}
                      borderRadius="100%"
                      mx="4px"
                    />
                  </Dot>,
                );
              }
              return dots;
            }}
          />
        </Center>
      </CarouselProvider>
    </>
  );
}
